import { TsDOM as q} from '@/scripts/core/TsDOM'
import { STabs } from '@/scripts/optional/s-tabs';
q.safeDefineElement(STabs)